// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".slide-show[data-v-ee103d7e]{max-width:400px;position:relative}.phone-image[data-v-ee103d7e]{width:100%}.absolute-box[data-v-ee103d7e]{left:0;position:absolute;top:0;width:100%}.slide-image[data-v-ee103d7e]{opacity:1;padding-right:20px;padding-top:10px;transition:opacity .4s ease-in-out;width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
